import { useQuery } from "react-query";
import { getScorecardException } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardException = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardException",
        getScorecardException,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};